import { Injectable, WritableSignal } from '@angular/core';

import { NavigationService } from '@core/services/navigation/navigation.service';

import { BaseProfileCommand } from '@shared/commands/base-profile.command';
import { IProfileCommandContext } from '@shared/models/profile-command.model';

@Injectable()
export class TransferAndPaymentsCommand extends BaseProfileCommand {
  readonly type = 'transferAndPayments';
  readonly title = 'Платежи и переводы';
  readonly subtitle?: WritableSignal<string> = undefined;
  readonly icon = 'transfer';
  readonly checkbox?: 'unchecked' | 'checked' | 'disabled' | null = null;
  readonly hidden = false;
  readonly group = 'main';
  readonly order = 1;
  readonly settingsNames?: string[] = undefined;

  constructor(private navigationService: NavigationService) {
    super();
  }

  async execute(_context: IProfileCommandContext): Promise<void> {
    await this.navigationService.push('/other/profile/transfer-and-payments');
  }
}
